/** @jsxImportSource theme-ui */
import { RouterProvider } from 'react-router-dom'
import { Suspense, useEffect } from 'react'
import Fallback from '@components/Fallback/Fallback'
import { Illustration } from '@infotrack/zenith-ui'
import router from '@routes/routes'
import { initialiseLogger } from '@utils/datadog'
import { getMarkdownEndpoint } from '@apis/markdownText'
import { getToken } from '@utils/authenticate'
import { useMarkdownText } from '@hooks/useMarkdownText'
import { firstTimeLoading } from '@utils/firstTimeLoading'
import { LocalStorageKey } from '@constants/index'
import { setLocalStorage } from '@utils/storage'

const App = () => {
  const { init } = useMarkdownText()

  // Extract the SSO callback token from the URL before the router renders and
  // determines auth state. Using searchParams.delete (not replaceState to pathname)
  // preserves any other query params such as ?oa=matching.
  const url = new URL(window.location.href)
  const urlToken = url.searchParams.get('token')
  if (urlToken) {
    setLocalStorage(LocalStorageKey.TOKEN, urlToken)
    url.searchParams.delete('token')
    window.history.replaceState(null, '', url.pathname + url.search)
  }

  useEffect(() => {
    firstTimeLoading()
    // start up datadog
    initialiseLogger({
      clientToken: process.env.CLIENT_TOKEN_DD || '',
      env: process.env.NODE_ENV || '',
      service: 'willregistry-ui-web',
      site: 'datadoghq.com'
    })

    init({
      token: getToken(),
      url: getMarkdownEndpoint(),
      Illustration: Illustration
    })
  }, [])

  return (
    <Suspense fallback={<Fallback />}>
      <RouterProvider router={router} fallbackElement={<Fallback />} />
    </Suspense>
  )
}
export default App
